import axios from 'axios';
import urlBase from './Configuration'
//const urlBase = 'https://localhost:44324';
const CategoryService ={
  getCategories: (categoryId:any)=>{
    return axios.get(`${urlBase}/category/${categoryId}/categories`);
  }
}
export { CategoryService }